import { motion } from 'framer-motion';
import { MapPin, List, Search, X } from 'lucide-react';

export const SearchAndFilters = ({ 
  searchQuery, 
  onSearchChange,
  selectedLocation, 
  onLocationChange,
  viewMode,
  onViewModeChange,
  locations
}) => {
  return (
    <motion.div
      data-testid="search-filters"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      className="absolute top-2 md:top-6 left-16 md:left-auto right-2 md:right-6 z-40 pointer-events-none"
    >
      <div className="flex flex-col items-end gap-1.5 md:gap-2 pointer-events-auto">
        {/* Search bar */}
        <div className="flex items-center gap-1.5 md:gap-2">
          <div className="relative">
            <input
              type="text"
              placeholder="Rechercher..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-32 md:w-56 pl-8 md:pl-9 pr-7 md:pr-8 py-1.5 md:py-2 bg-white/95 backdrop-blur-lg rounded-full border border-gray-200 font-dm text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-[#97c7c3] focus:border-transparent shadow-lg"
              data-testid="search-input"
            />
            <Search className="absolute left-2.5 md:left-3 top-1/2 -translate-y-1/2 w-3.5 md:w-4 h-3.5 md:h-4 text-gray-400" />
            {searchQuery && (
              <button
                onClick={() => onSearchChange('')}
                className="absolute right-2.5 md:right-3 top-1/2 -translate-y-1/2 p-0.5 hover:bg-gray-100 rounded-full"
              >
                <X className="w-3 h-3 text-gray-400" />
              </button>
            )}
          </div>

          {/* View mode toggle - Desktop only */}
          <div className="hidden md:flex items-center bg-white/95 backdrop-blur-lg rounded-full p-1 shadow-lg border border-gray-200">
            <button
              onClick={() => onViewModeChange('map')}
              className={`p-2 rounded-full transition-colors ${
                viewMode === 'map' ? 'bg-[#97c7c3] text-black' : 'text-gray-500 hover:bg-gray-100'
              }`}
              data-testid="view-map-btn"
            >
              <MapPin className="w-4 h-4" />
            </button>
            <button
              onClick={() => onViewModeChange('list')}
              className={`p-2 rounded-full transition-colors ${
                viewMode === 'list' ? 'bg-[#97c7c3] text-black' : 'text-gray-500 hover:bg-gray-100'
              }`}
              data-testid="view-list-btn"
            >
              <List className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Location filters */}
        <div className="flex items-center gap-1.5 md:gap-2 overflow-x-auto no-scrollbar max-w-[calc(100vw-80px)] md:max-w-none pb-1">
          {locations.map((location) => (
            <motion.button
              key={location}
              whileTap={{ scale: 0.95 }}
              onClick={() => onLocationChange(location)}
              className={`flex-shrink-0 px-3 md:px-4 py-1.5 md:py-2 rounded-full font-dm text-xs md:text-sm font-medium transition-all duration-200 shadow-md min-h-[36px] md:min-h-[44px] ${
                selectedLocation === location 
                  ? 'bg-[#97c7c3] text-black border-2 border-[#97c7c3]' 
                  : 'bg-white/95 backdrop-blur-lg text-gray-800 border border-gray-300 hover:border-[#97c7c3] hover:bg-[#97c7c3]/10 hover:text-black'
              }`}
              data-testid={`filter-${location.toLowerCase().replace(/[^a-z]/g, '-')}`}
            >
              {location}
            </motion.button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
